import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const classesShape = PropTypes.shape({
  disabled: PropTypes.string,
  focused: PropTypes.string,
  menuInner: PropTypes.string,
  menuOuter: PropTypes.string,
  optionValue: PropTypes.string,
  row: PropTypes.string,
  searchSelectInputWrapper: PropTypes.string,
  selectToggle: PropTypes.string,
  singleSelect: PropTypes.string,
  valueOptionWrapper: PropTypes.string,
});
